<template>
	<div :class="`dashboard ${toggleTheme ? '' : 'black'}`">
		<el-row :gutter="20">
			<el-col :span="14" class="dashboard__col">
				<div class="dashboard__all">
					<el-row :gutter="20">
						<el-col :span="12" class="dashboard__span">
							<el-card class="dashboard__card">
								<router-link to="/admin/booklist" class="dashboard__item">
									<div class="dashboard__all">
										<div class="dashboard__count">
											{{bookscount}}
										</div>
										<div class="dashboard__title">
											{{$t('admin.ebook')}}
										</div>
									</div>
									<div class="dashboard__icon">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.17 2.06C20.4532 1.93653 19.7274 1.87298 19 1.87C16.5184 1.86796 14.0885 2.57957 12 3.92C9.90617 2.59717 7.47667 1.90303 5.00002 1.92C4.27267 1.92298 3.54683 1.98653 2.83002 2.11C2.59523 2.15048 2.3826 2.27346 2.23044 2.45679C2.07827 2.64013 1.99656 2.87177 2.00002 3.11V15.11C1.99788 15.2569 2.02815 15.4025 2.08867 15.5364C2.1492 15.6703 2.23849 15.7893 2.3502 15.8847C2.4619 15.9802 2.59328 16.0499 2.73498 16.0888C2.87668 16.1278 3.02522 16.135 3.17002 16.11C4.60304 15.8619 6.07123 15.9031 7.48809 16.2311C8.90495 16.5591 10.2418 17.1674 11.42 18.02L11.54 18.09H11.65C11.7609 18.1362 11.8799 18.16 12 18.16C12.1202 18.16 12.2391 18.1362 12.35 18.09H12.46L12.58 18.02C13.75 17.1483 15.083 16.5203 16.5002 16.1734C17.9173 15.8264 19.3897 15.7674 20.83 16C20.9748 16.025 21.1234 16.0178 21.2651 15.9788C21.4068 15.9399 21.5381 15.8702 21.6498 15.7747C21.7616 15.6793 21.8508 15.5603 21.9114 15.4264C21.9719 15.2925 22.0022 15.1469 22 15V3C21.9896 2.77215 21.9016 2.55471 21.7507 2.38374C21.5997 2.21276 21.3948 2.09854 21.17 2.06ZM11 15.35C9.14991 14.3767 7.09054 13.8687 5.00002 13.87C4.67002 13.87 4.34002 13.87 4.00002 13.87V3.87C4.33308 3.8508 4.66697 3.8508 5.00002 3.87C7.13341 3.86764 9.22024 4.49369 11 5.67V15.35ZM20 13.91C19.66 13.91 19.33 13.91 19 13.91C16.9095 13.9087 14.8501 14.4167 13 15.39V5.67C14.7798 4.49369 16.8666 3.86764 19 3.87C19.3331 3.8508 19.667 3.8508 20 3.87V13.91ZM21.17 18.06C20.4532 17.9365 19.7274 17.873 19 17.87C16.5184 17.868 14.0885 18.5796 12 19.92C9.91154 18.5796 7.48166 17.868 5.00002 17.87C4.27267 17.873 3.54683 17.9365 2.83002 18.06C2.69985 18.0807 2.57505 18.1268 2.46279 18.1959C2.35053 18.265 2.25302 18.3555 2.17589 18.4624C2.09876 18.5693 2.04351 18.6903 2.01333 18.8186C1.98315 18.9469 1.97862 19.0799 2.00002 19.21C2.05084 19.4697 2.20251 19.6986 2.42181 19.8467C2.64111 19.9948 2.91016 20.0499 3.17002 20C4.60304 19.7519 6.07123 19.7931 7.48809 20.1211C8.90495 20.4491 10.2418 21.0574 11.42 21.91C11.5894 22.0306 11.7921 22.0954 12 22.0954C12.2079 22.0954 12.4107 22.0306 12.58 21.91C13.7582 21.0574 15.0951 20.4491 16.512 20.1211C17.9288 19.7931 19.397 19.7519 20.83 20C21.0899 20.0499 21.3589 19.9948 21.5782 19.8467C21.7975 19.6986 21.9492 19.4697 22 19.21C22.0214 19.0799 22.0169 18.9469 21.9867 18.8186C21.9565 18.6903 21.9013 18.5693 21.8242 18.4624C21.747 18.3555 21.6495 18.265 21.5373 18.1959C21.425 18.1268 21.3002 18.0807 21.17 18.06V18.06Z" fill="#61A369"/>
										</svg>
									</div>
								</router-link>
							</el-card>
						</el-col>
						<el-col :span="12" class="dashboard__span">
							<el-card class="dashboard__card" style="background:#FFF5F5;">
								<router-link to="/admin/paperbook" class="dashboard__item">
								<div class="dashboard__all">
										<div class="dashboard__count">
											{{countPaperBook}}
										</div>
										<div class="dashboard__title">
											{{$t('admin.paperbook')}}
										</div>
									</div>
									<div class="dashboard__icon">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 2H8C6.93913 2 5.92172 2.42143 5.17157 3.17157C4.42143 3.92172 4 4.93913 4 6V18C4 19.0609 4.42143 20.0783 5.17157 20.8284C5.92172 21.5786 6.93913 22 8 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4H18V14H8C7.29504 14.003 6.60399 14.1964 6 14.56V6ZM8 20C7.46957 20 6.96086 19.7893 6.58579 19.4142C6.21071 19.0391 6 18.5304 6 18C6 17.4696 6.21071 16.9609 6.58579 16.5858C6.96086 16.2107 7.46957 16 8 16H18V20H8ZM10 8H14C14.2652 8 14.5196 7.89464 14.7071 7.70711C14.8946 7.51957 15 7.26522 15 7C15 6.73478 14.8946 6.48043 14.7071 6.29289C14.5196 6.10536 14.2652 6 14 6H10C9.73478 6 9.48043 6.10536 9.29289 6.29289C9.10536 6.48043 9 6.73478 9 7C9 7.26522 9.10536 7.51957 9.29289 7.70711C9.48043 7.89464 9.73478 8 10 8V8Z" fill="#CF5555"/>            		</svg>
									</div>
									
								</router-link>
							</el-card>
						</el-col>
						<el-col :span="12" class="dashboard__span">
							<el-card class="dashboard__card" style="background:#FBFAEC;">
								<router-link to="/admin/subs" class="dashboard__item">
								<div class="dashboard__all">
										<div class="dashboard__count">
											{{subcategory.length}}
										</div>
										<div class="dashboard__title">
											{{$t('admin.subcategory')}}
										</div>
									</div>
									<div class="dashboard__icon">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9998 7.91002C17.9698 7.91002 17.9498 7.91002 17.9198 7.91002H17.8698C15.9798 7.85002 14.5698 6.39001 14.5698 4.59001C14.5698 2.75001 16.0698 1.26001 17.8998 1.26001C19.7298 1.26001 21.2298 2.76001 21.2298 4.59001C21.2198 6.40001 19.8098 7.86001 18.0098 7.92001C18.0098 7.91001 18.0098 7.91002 17.9998 7.91002ZM17.8998 2.75002C16.8898 2.75002 16.0698 3.57002 16.0698 4.58002C16.0698 5.57002 16.8398 6.37002 17.8298 6.41002C17.8398 6.40002 17.9198 6.40002 18.0098 6.41002C18.9798 6.36002 19.7298 5.56002 19.7398 4.58002C19.7398 3.57002 18.9198 2.75002 17.8998 2.75002Z" fill="#DABE77"/>     <path d="M18.01 15.28C17.62 15.28 17.23 15.25 16.84 15.18C16.43 15.11 16.16 14.72 16.23 14.31C16.3 13.9 16.69 13.63 17.1 13.7C18.33 13.91 19.63 13.68 20.5 13.1C20.97 12.79 21.22 12.4 21.22 12.01C21.22 11.62 20.96 11.24 20.5 10.93C19.63 10.35 18.31 10.12 17.07 10.34C16.66 10.42 16.27 10.14 16.2 9.73002C16.13 9.32002 16.4 8.93003 16.81 8.86003C18.44 8.57003 20.13 8.88002 21.33 9.68002C22.21 10.27 22.72 11.11 22.72 12.01C22.72 12.9 22.22 13.75 21.33 14.35C20.42 14.95 19.24 15.28 18.01 15.28Z" fill="#DABE77"/><path d="M5.96998 7.91C5.95998 7.91 5.94998 7.91 5.94998 7.91C4.14998 7.85 2.73998 6.39 2.72998 4.59C2.72998 2.75 4.22998 1.25 6.05998 1.25C7.88998 1.25 9.38998 2.75 9.38998 4.58C9.38998 6.39 7.97998 7.85 6.17998 7.91L5.96998 7.16L6.03998 7.91C6.01998 7.91 5.98998 7.91 5.96998 7.91ZM6.06998 6.41C6.12998 6.41 6.17998 6.41 6.23998 6.42C7.12998 6.38 7.90998 5.58 7.90998 4.59C7.90998 3.58 7.08998 2.75999 6.07998 2.75999C5.06998 2.75999 4.24998 3.58 4.24998 4.59C4.24998 5.57 5.00998 6.36 5.97998 6.42C5.98998 6.41 6.02998 6.41 6.06998 6.41Z" fill="#DABE77"/>   <path d="M5.96 15.28C4.73 15.28 3.55 14.95 2.64 14.35C1.76 13.76 1.25 12.91 1.25 12.01C1.25 11.12 1.76 10.27 2.64 9.68002C3.84 8.88002 5.53 8.57003 7.16 8.86003C7.57 8.93003 7.84 9.32002 7.77 9.73002C7.7 10.14 7.31 10.42 6.9 10.34C5.66 10.12 4.35 10.35 3.47 10.93C3 11.24 2.75 11.62 2.75 12.01C2.75 12.4 3.01 12.79 3.47 13.1C4.34 13.68 5.64 13.91 6.87 13.7C7.28 13.63 7.67 13.91 7.74 14.31C7.81 14.72 7.54 15.11 7.13 15.18C6.74 15.25 6.35 15.28 5.96 15.28Z" fill="#DABE77"/><path d="M11.9998 15.38C11.9698 15.38 11.9498 15.38 11.9198 15.38H11.8698C9.97982 15.32 8.56982 13.86 8.56982 12.06C8.56982 10.22 10.0698 8.72998 11.8998 8.72998C13.7298 8.72998 15.2298 10.23 15.2298 12.06C15.2198 13.87 13.8098 15.33 12.0098 15.39C12.0098 15.38 12.0098 15.38 11.9998 15.38ZM11.8998 10.22C10.8898 10.22 10.0698 11.04 10.0698 12.05C10.0698 13.04 10.8398 13.84 11.8298 13.88C11.8398 13.87 11.9198 13.87 12.0098 13.88C12.9798 13.83 13.7298 13.03 13.7398 12.05C13.7398 11.05 12.9198 10.22 11.8998 10.22Z" fill="#DABE77"/>  <path d="M11.9998 22.76C10.7998 22.76 9.59978 22.45 8.66978 21.82C7.78978 21.23 7.27979 20.39 7.27979 19.49C7.27979 18.6 7.77978 17.74 8.66978 17.15C10.5398 15.91 13.4698 15.91 15.3298 17.15C16.2098 17.74 16.7198 18.58 16.7198 19.48C16.7198 20.37 16.2198 21.23 15.3298 21.82C14.3998 22.44 13.1998 22.76 11.9998 22.76ZM9.49979 18.41C9.02979 18.72 8.77979 19.11 8.77979 19.5C8.77979 19.89 9.03979 20.27 9.49979 20.58C10.8498 21.49 13.1398 21.49 14.4898 20.58C14.9598 20.27 15.2098 19.88 15.2098 19.49C15.2098 19.1 14.9498 18.72 14.4898 18.41C13.1498 17.5 10.8598 17.51 9.49979 18.41Z" fill="#DABE77"/>      			</svg>
									</div>
								</router-link>
							</el-card>
						</el-col>
						<el-col :span="12" class="dashboard__span">
							<el-card class="dashboard__card" style="background:#F4F9FE;">
								<div class="overlay"></div>
								<router-link to="/admin/givebook" class="dashboard__item">
								<div class="dashboard__all">
										<div class="dashboard__count">
											{{countGiveBook}}
										</div>
										<div class="dashboard__title">
											Olingan kitoblar
										</div>
									</div>
									<div class="dashboard__icon">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 22.75H8C4.98 22.75 3.25 21.02 3.25 18V8.25C3.25 5.1 4.85 3.5 8 3.5C8.41 3.5 8.75 3.84 8.75 4.25C8.75 4.65 8.91 5.03 9.19 5.31C9.47 5.59 9.85 5.75 10.25 5.75H13.75C14.58 5.75 15.25 5.08 15.25 4.25C15.25 3.84 15.59 3.5 16 3.5C19.15 3.5 20.75 5.1 20.75 8.25V18C20.75 21.02 19.02 22.75 16 22.75ZM7.34998 5.02C5.76998 5.15 4.75 5.86 4.75 8.25V18C4.75 20.22 5.78 21.25 8 21.25H16C18.22 21.25 19.25 20.22 19.25 18V8.25C19.25 5.86 18.23 5.16 16.65 5.02C16.31 6.3 15.14 7.25 13.75 7.25H10.25C9.45 7.25 8.7 6.94 8.13 6.37C7.75 5.99 7.48998 5.53 7.34998 5.02Z" fill="#4281BF"/><path d="M13.75 7.25H10.25C9.45 7.25 8.7 6.94 8.13 6.37C7.56 5.8 7.25 5.05 7.25 4.25C7.25 2.6 8.6 1.25 10.25 1.25H13.75C14.55 1.25 15.3 1.56 15.87 2.13C16.44 2.7 16.75 3.45 16.75 4.25C16.75 5.9 15.4 7.25 13.75 7.25ZM10.25 2.75C9.42 2.75 8.75 3.42 8.75 4.25C8.75 4.65 8.91 5.03 9.19 5.31C9.47 5.59 9.85 5.75 10.25 5.75H13.75C14.58 5.75 15.25 5.08 15.25 4.25C15.25 3.85 15.09 3.47 14.81 3.19C14.53 2.91 14.15 2.75 13.75 2.75H10.25Z" fill="#4281BF"/><path d="M12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z" fill="#4281BF"/><path d="M16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z" fill="#4281BF"/> </svg>
									</div>
								</router-link>
							</el-card>
						</el-col>
					</el-row>
				</div>
				
				<div class="dashboard__ebook">
					<div class="dashboard__etitle">
						Oxirgi qo'shilgan elektron kitoblar
					</div>
					<el-row :gutter="20">  
						<el-col :span="12" v-for="(book, index) of ebooks" :key="index" class="dashboard__span">
							<div  class="dashboard__ecard">
								<el-image :src="`${this.url}/${book.avatar}`" fit="cover" class="dashboard__img" v-if="book.avatar" />
								<div class="dashboard__avatar" v-else>
									{{book.avatar}}
									<img src="@/assets/logo.svg" alt="">
								</div>
								<div class="dashboard__info">
									<div class="dashboard__info-name">
										{{book.title}}
									</div>
									<div class="dashboard__info-cat">
										{{book.category.title}}
									</div>
									<div class="dashboard__info-author">
										{{book.author.toString()}}
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="dashboard__paperbook">
					<div class="dashboard__etitle">
						Oxirgi qo'shilgan qog'oz kitoblar
					</div>
					<el-row :gutter="20">
						<el-col :span="12" v-for="(pbook, index) of pbooks" :key="index" class="dashboard__span">
							<router-link to="/admin/paperbook" class="dashboard__ecard">
								<div class="dashboard__avatar">
									<img src="@/assets/logo.svg" alt="">
								</div>
								<div class="dashboard__info">
									<div class="dashboard__info-name">
										{{pbook.title}}
									</div>
									<div class="dashboard__info-cat">
										{{pbook.category.title}}
									</div>
									<div class="dashboard__info-author">
										{{pbook.author.toString()}}
									</div>
								</div>
							</router-link>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col :span="10" class="dashboard__col">
				<div class="chart_container">
					<Bar :data="chartData" :options="chartOptions" />
				</div>
				<div class="dashboard__reader">
					<div class="dashboard__reader-all">
						<div class="dashboard__reader-title">
							Top kitobxonlar
						</div>
						<div class="dashboard__reader-other">
							<router-link to="">
								Barchasi
							</router-link>
						</div>
					</div>
					<div class="dashboard__reader-humans">
						<div class="dashboard__reader-flex">
							<div class="dashboard__reader-avatar">
								<svg fill="#F4F6F8" width="50px" height="50px" viewBox="0 0 24 24" id="user" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M21,20a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2,6,6,0,0,1,6-6h6A6,6,0,0,1,21,20Zm-9-8A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z" style="fill: #F4F6F8;"></path></svg>
							</div>
							<div class="dashboard__reader-name">
								Katryn
							</div>
						</div>
						<div class="dashboard__reader-flex">
							<div class="dashboard__reader-avatar">
								<svg fill="#F4F6F8" width="50px" height="50px" viewBox="0 0 24 24" id="user" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M21,20a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2,6,6,0,0,1,6-6h6A6,6,0,0,1,21,20Zm-9-8A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z" style="fill: #F4F6F8;"></path></svg>
							</div>
							<div class="dashboard__reader-name">
								Katryn
							</div>
						</div>
						<div class="dashboard__reader-flex">
							<div class="dashboard__reader-avatar">
								<svg fill="#F4F6F8" width="50px" height="50px" viewBox="0 0 24 24" id="user" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M21,20a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2,6,6,0,0,1,6-6h6A6,6,0,0,1,21,20Zm-9-8A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z" style="fill: #F4F6F8;"></path></svg>
							</div>
							<div class="dashboard__reader-name">
								Katryn
							</div>
						</div>
						<div class="dashboard__reader-flex">
							<div class="dashboard__reader-avatar">
								<svg fill="#F4F6F8" width="50px" height="50px" viewBox="0 0 24 24" id="user" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M21,20a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2,6,6,0,0,1,6-6h6A6,6,0,0,1,21,20Zm-9-8A5,5,0,1,0,7,7,5,5,0,0,0,12,12Z" style="fill: #F4F6F8;"></path></svg>
							</div>
							<div class="dashboard__reader-name">
								Katryn
							</div>
						</div>
					</div>
				</div>
				<div class="dashboard__give">
					<div class="dashboard__give-title">
						Oxirgi marta olingan kitoblar
					</div>
					<div class="dashboard__give-card" v-for="(gbook, index) of giveBooks" :key="index">
						<div class="df">
							<div class="dashboard__give-avatar">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 22.75H8C4.98 22.75 3.25 21.02 3.25 18V8.25C3.25 5.1 4.85 3.5 8 3.5C8.41 3.5 8.75 3.84 8.75 4.25C8.75 4.65 8.91 5.03 9.19 5.31C9.47 5.59 9.85 5.75 10.25 5.75H13.75C14.58 5.75 15.25 5.08 15.25 4.25C15.25 3.84 15.59 3.5 16 3.5C19.15 3.5 20.75 5.1 20.75 8.25V18C20.75 21.02 19.02 22.75 16 22.75ZM7.34998 5.02C5.76998 5.15 4.75 5.86 4.75 8.25V18C4.75 20.22 5.78 21.25 8 21.25H16C18.22 21.25 19.25 20.22 19.25 18V8.25C19.25 5.86 18.23 5.16 16.65 5.02C16.31 6.3 15.14 7.25 13.75 7.25H10.25C9.45 7.25 8.7 6.94 8.13 6.37C7.75 5.99 7.48998 5.53 7.34998 5.02Z" fill="#4281BF"/><path d="M13.75 7.25H10.25C9.45 7.25 8.7 6.94 8.13 6.37C7.56 5.8 7.25 5.05 7.25 4.25C7.25 2.6 8.6 1.25 10.25 1.25H13.75C14.55 1.25 15.3 1.56 15.87 2.13C16.44 2.7 16.75 3.45 16.75 4.25C16.75 5.9 15.4 7.25 13.75 7.25ZM10.25 2.75C9.42 2.75 8.75 3.42 8.75 4.25C8.75 4.65 8.91 5.03 9.19 5.31C9.47 5.59 9.85 5.75 10.25 5.75H13.75C14.58 5.75 15.25 5.08 15.25 4.25C15.25 3.85 15.09 3.47 14.81 3.19C14.53 2.91 14.15 2.75 13.75 2.75H10.25Z" fill="#4281BF"/><path d="M12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z" fill="#4281BF"/><path d="M16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z" fill="#4281BF"/> </svg>
						</div>
						<div class="dashboard__give-book">
							<div class="dashboard__give-name">
								{{gbook.paperbook?.title}}
							</div>
							<div class="dashboard__give-user">
								<img src="@/assets/icons/user-book.svg" alt="">
								{{gbook.paperbook?.author?.toString()}}
							</div>
						</div>
						</div>
						<div class="dashboard__give-right">
							<el-icon><ArrowRight/></el-icon>
							<div class="dashboard__give-date">
								{{gbook.date}}
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		
	</div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

import {mapActions, mapGetters} from 'vuex'
	export default {
		components: { Bar },
		data(){
			return{
				chartData: {
					type: Object,
					required: true
				},
				chartOptions: {
					type: Object,
					default: () => {}
				},
				chartData: {
					labels: [ 'Dush', 'Sesh', 'Chor','Pay','Juma','Shan','Yak'],
					datasets: [
						{
							label: 'Data One',
							backgroundColor: '#D9D9D9',
							data: [40, 20, 12, 17,19, 10,25],
							borderRadius:10,
							height:310
						}
					],
					
				},
				options: {
						plugins: {
							legend:{
								labels:{
									color:'white',
									font: {
                        size: 24
                    }
								}
							}
						},
						responsive:true
				},
			}
		},
		computed: {
			...mapGetters([
				'subcategory','users',
				'countPaperBook',
				'bookscount','toggleTheme',
				'ebooks','pbooks','url',
				'giveBooks','countGiveBook'
			]),
		},
		methods: {
			...mapActions(['allEbook','allPbook','allGbook','getGiveBook','allPaperBook']),
			getDate(date) {
				let dateFormat = new Date(date)
				return date ? `${dateFormat.getDate()}-${dateFormat.getUTCMonth()+1}-${dateFormat.getFullYear()}` : ''
			},
		},
		mounted(){
			// this.getGiveBook()

			this.allEbook()
			this.allPbook()
			this.allPaperBook()
		}

	}
</script>

<style lang="scss">
@import '@/styles/view/dashboard.scss';
@import '@/styles/media.scss';
</style>